"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOAuthError = exports.errors = void 0;
const okta_auth_js_1 = require("@okta/okta-auth-js");
exports.errors = {
    userNotLoggedIn: "No user is logged in",
    newPasswordRequired: "New password required",
    failedToInitService: "Failed to init service"
};
const isOAuthError = (e) => e instanceof okta_auth_js_1.OAuthError;
exports.isOAuthError = isOAuthError;
//# sourceMappingURL=errors.js.map